/* YoshMarket — Injecte le snippet rating Judge.me sous le titre produit.
   Aucune modification de main-product.liquid nécessaire. */
(function () {
  function injectSnippet() {
    // Tourne uniquement sur les pages produit
    var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__title');
    if (!titleEl) return;

    // Pas de double injection
    if (document.querySelector('.product__rating-snippet')) return;

    // Récupère le product ID depuis le widget Judge.me déjà présent en bas de page
    var existing = document.querySelector('#judgeme_product_reviews, [data-product-id]');
    var productId = existing && (existing.dataset.productId || existing.getAttribute('data-product-id'));
    if (!productId) return;

    // Construit le snippet badge
    var wrap = document.createElement('div');
    wrap.className = 'product__rating-snippet';
    var badge = document.createElement('div');
    badge.className = 'jdgm-widget jdgm-preview-badge';
    badge.setAttribute('data-id', productId);
    badge.setAttribute('data-product-id', productId);
    badge.setAttribute('data-template', 'product');
    wrap.appendChild(badge);

    // Insertion juste sous le bloc titre
    var titleBlock = titleEl.closest('.product__title') || titleEl;
    if (titleBlock.parentNode) {
      titleBlock.parentNode.insertBefore(wrap, titleBlock.nextSibling);
    }

    // Re-render Judge.me si déjà chargé
    if (window.jdgm && typeof window.jdgm.runWidgets === 'function') {
      try { window.jdgm.runWidgets(); } catch (e) {}
    } else {
      // sinon on attend que jdgm se charge
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (window.jdgm && typeof window.jdgm.runWidgets === 'function') {
          try { window.jdgm.runWidgets(); } catch (e) {}
          clearInterval(iv);
        } else if (tries > 50) {
          clearInterval(iv);
        }
      }, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectSnippet);
  } else {
    injectSnippet();
  }

  // Re-injection à chaque changement de page (Shopify section rendering API)
  document.addEventListener('shopify:section:load', injectSnippet);
})();
